import { Children } from '@/utils/reactTypes';
import { Box, SxProps } from '@mui/material';
import Tooltip from '@mui/material/Tooltip';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Unstable_Grid2';
import { useTheme } from '@mui/material/styles';

export const AxlePageHeader = ({
    title,
    description = '',
    children = null,
    sx,
}: {
    title: string;
    description?: string;
    children?: Children;
    sx?: SxProps;
}) => {
    const theme = useTheme();
    return (
        <Box mb={3} sx={sx}>
            <Grid container spacing={2} sx={{ justifyContent: 'space-between' }}>
                <Grid display={'flex'} alignItems={'center'}>
                    <Tooltip title={description} placement='right-end'>
                        <Typography variant='h1'>{title}</Typography>
                    </Tooltip>
                </Grid>
                {/* Let this content-width ('auto') grid item shrink below its content on
                    smaller screens so the inner flexWrap actually wraps the actions onto
                    multiple lines instead of overflowing the page. Grid2's own
                    `flex: 0 0 auto` (compound-class specificity) pins flex-shrink to 0, so we
                    override flex-shrink with !important; minWidth: 0 lets it shrink past
                    min-content. flex-grow stays 0, so desktop layout is unchanged. */}
                <Grid xs={12} sm={'auto'} sx={{ minWidth: 0, flexShrink: '1 !important' }}>
                    <Box
                        style={{
                            display: 'flex',
                            gap: theme.spacing(2),
                            alignItems: 'center',
                            flexWrap: 'wrap',
                            // This helps visually align the title with any buttons:
                            paddingBottom: theme.spacing(1),
                        }}
                    >
                        {children}
                    </Box>
                </Grid>
            </Grid>
        </Box>
    );
};
